import React from 'react';
import { LabelCanvas } from './LabelCanvas';
import { PrintGuidance } from './PrintGuidance';
import { Button } from '@/components/ui/button';
import { Download, Eye } from 'lucide-react';
import { LabelTemplate } from '@/types/label';
import { exportLabelPdf } from '@/lib/pdfExport';

interface PreviewPanelProps {
  template: LabelTemplate;
  resolveContent: (content: string) => string;
}

export const PreviewPanel: React.FC<PreviewPanelProps> = ({
  template,
  resolveContent,
}) => {
  const handleExport = async () => {
    await exportLabelPdf(template, resolveContent);
  };

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center justify-between px-3 sm:px-4 py-2 sm:py-2.5 border-b border-border/50 bg-card">
        <div className="flex items-center gap-1.5 sm:gap-2">
          <Eye className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-muted-foreground" />
          <span className="text-[10px] sm:text-xs font-medium text-muted-foreground uppercase tracking-wide">Preview</span>
          <span className="text-[9px] sm:text-[10px] text-muted-foreground hidden xs:inline">(3× zoom)</span>
        </div>
        <Button onClick={handleExport} size="sm" className="h-7 sm:h-8 px-2 sm:px-2.5 text-[10px] sm:text-xs gap-1 sm:gap-1.5">
          <Download className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
          <span className="hidden xs:inline">Export</span>
        </Button>
      </div>

      <div className="flex-1 overflow-auto">
        <LabelCanvas
          template={template}
          selectedElementId={null}
          onSelectElement={() => {}}
          onUpdateElement={() => {}}
          resolveContent={resolveContent}
          showGrid={false}
          scale={3}
        />
      </div>

      <div className="p-3 sm:p-4 bg-muted/50">
        <PrintGuidance />
      </div>
    </div>
  );
};
